import {
  faArrowRight as faArrowRightRegular,
  faArrowUpRight as faArrowUpRightRegular,
  faBars as faBarsRegular,
  faLock as faLockRegular,
  faXmark as faXmarkRegular,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faCircleInfo as faCircleInfoSolid,
  faMinus as faMinusSolid,
  faPlus as faPlusSolid,
} from "@fortawesome/pro-solid-svg-icons";

const regularIcons = [
  faBarsRegular,
  faXmarkRegular,
  faArrowUpRightRegular,
  faArrowRightRegular,
  faLockRegular,
];
const solidIcons = [faCircleInfoSolid, faMinusSolid, faPlusSolid];

export default [...regularIcons, ...solidIcons];
